const roundByNum = (num, rounder) => {
  const multiplier = 1 / (rounder || 0.5);
  return Math.round(num * multiplier) / multiplier;
}

const ratingGroups = document.querySelectorAll(".i-rating");

ratingGroups.forEach(rating => {
  const ratingStars = rating.querySelector(".g-rating__stars");
  if (ratingStars) {
    const percentage = parseInt(ratingStars.getAttribute('data-percentage'));
    const stars = ratingStars.querySelectorAll(".i-star");

    const starsCount = ratingStars.children.length;
    let calc = (percentage / 100) * starsCount
    calc = (roundByNum(calc))
    const fullStars = Math.floor(calc);

    for (let i = 0; i < fullStars; i++) {
      stars[i].classList.add("--full")
    }

    if (calc != fullStars) {
      const halfStar = ratingStars.children.item(fullStars).querySelector(".i-star");
      halfStar.classList.add("--half")
    }
  }
});
